var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6C4 5.62542 4.20595 5.29894 4.5108 5.12763C4.77485 5.35945 5.12101 5.5 5.5 5.5C6.32843 5.5 7 4.82843 7 4C7 3.17157 6.32843 2.5 5.5 2.5C5.01912 2.5 4.59109 2.72629 4.31659 3.07819C2.98901 3.38749 2 4.57825 2 6V9.5C2 12.5915 4.15824 15.1789 7.0502 15.8377C7.31155 18.0087 8.57847 19.9528 10.5 21.0622C12.6658 22.3126 15.3342 22.3126 17.5 21.0622C19.6658 19.8117 21 17.5009 21 15V12.8293C22.1652 12.4175 23 11.3062 23 10C23 8.34315 21.6569 7 20 7C18.3431 7 17 8.34315 17 10C17 11.3062 17.8348 12.4175 19 12.8293V15C19 16.7863 18.047 18.437 16.5 19.3301C14.953 20.2233 13.047 20.2233 11.5 19.3301C10.2391 18.6021 9.37275 17.3709 9.09549 15.9731C12.4062 15.6724 15 12.8891 15 9.5V6C15 4.57825 14.011 3.38749 12.6834 3.07819C12.4089 2.72629 11.9809 2.5 11.5 2.5C10.6716 2.5 10 3.17157 10 4C10 4.82843 10.6716 5.5 11.5 5.5C11.879 5.5 12.2251 5.35944 12.4892 5.12762C12.794 5.29894 13 5.62542 13 6V9.5C13 11.9853 10.9853 14 8.5 14C6.01472 14 4 11.9853 4 9.5V6ZM20 11C20.5523 11 21 10.5523 21 10C21 9.44772 20.5523 9 20 9C19.4477 9 19 9.44772 19 10C19 10.5523 19.4477 11 20 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.317d75cbfd700d4d7e94784476cf1e91.svg";
export { ForwardRef as ReactComponent };